import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    selectedOption: "",
    amountsConvertedIn: "",
    isRoundEnabledThousand: true,
    isRoundEnabledMillion: true,
    tbLibClearFilter: false,
    tbLibDisableFilter: true,
    tbClearFilter : false,
    tbDisableFilter : true,
    showTbLibraryColumns: {
        "Account Type": {
            name: 'accountType',
            type: "QBO",
            isSelected: true
        },
        "Detail Type": {
            name: 'detailType',
            type: "QBO",
            isSelected: true
        },
        "Statement": {
            name: 'statement',
            type: "FS",
            isSelected: true
        },
        "Head":  {
            name: 'head',
            type: "FS",
            isSelected: true
        },
        "Caption": {
            name: 'caption',
            type: "FS",
            isSelected: true
        },
        "Alternate Captions": {
            name: 'alternateCaption',
            type: "FS",
            isSelected: true
        }
    },
}

const optionSelectorSlice = createSlice({
    name: 'tbSlice',
    initialState,
    reducers: {
        setSelectedOption(state, action) {
            state.selectedOption = action.payload;
        },
        setAmountConvertedIn(state, action) {
            state.amountsConvertedIn = action.payload;
        },
        setIsRoundEnabledThousand(state, action) {
            state.isRoundEnabledThousand = action.payload;
        },
        setIsRoundEnabledMillion(state, action) {
            state.isRoundEnabledMillion = action.payload;
        },
        setShowLibraryColumns: (state, action) => {
            const { column } = action.payload;
            if (column && state.showTbLibraryColumns[column]) {
              state.showTbLibraryColumns[column].isSelected = !state.showTbLibraryColumns[column].isSelected;
            }
        },
        setTbLibClearFilter(state, action) {
            state.tbLibClearFilter = action.payload;
        },
        setTbLibDisableClearFilter(state, action) {
            state.tbLibDisableFilter = action.payload;
        },
        setTbClearFilter(state, action){
            state.tbClearFilter = action.payload
        },
        setTbDisableClearFilter(state, action){
            state.tbDisableFilter = action.payload
        }
    }
});

export const { setSelectedOption, setAmountConvertedIn, setIsRoundEnabledThousand, setIsRoundEnabledMillion, setShowLibraryColumns, setTbLibClearFilter, setTbLibDisableClearFilter, setTbClearFilter, setTbDisableClearFilter } = optionSelectorSlice.actions;

export default optionSelectorSlice;